export default __webpack_public_path__ + "static/media/big ben.22022d37.svg";